var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"listBox"},[_c('div',{staticClass:"title"},[_vm._v("项目展示")]),_c('div',{staticClass:"content"},_vm._l((_vm.titleList),function(item){return _c('router-link',{key:item.id,staticClass:"item",attrs:{"to":{
          name: 'Detail',
          query: {
            id: item.id
          }
        }}},[_vm._v(_vm._s(item.title))])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }